import React from 'react'
import {Image, ImageProps, Link, LinkProps, Stack, StackProps, Text, TextProps, useMultiStyleConfig} from '@chakra-ui/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {FooterCopyright} from '_types'

/**
 * @name FooterCopyrightComponent
 *
 * @component
 *
 * @description
 * Renders the legal labels and image in the bottom footer.
 *
 * @param {FooterCopyright} props - The properties object.
 * @param {string} props.text1 - Main legal label.
 * @param {FooterCopyrightText2} props.text2 - An object containing 2 links, it's specified for china at the moment.
 *
 * @returns {React.FC<FooterCopyright>} - Rendered `FooterCopyrightComponent`.
 */
const FooterCopyrightComponent: React.FC<FooterCopyright> = ({text1, text2}) => {
    const styles = useMultiStyleConfig('FooterLegal') as Record<string, TextProps & ImageProps & LinkProps & StackProps>

    return (
        <Stack data-testid="footer-legal" {...styles.legalContainer}>
            <Text {...styles.copyrightText}>{text1}</Text>
            {text2 && (
                <Text {...styles.copyrightText}>
                    {text2.link1 && (
                        <>
                            <Link {...styles.copyrightLink} href={text2.link1.href}>
                                {text2.link1.name}
                            </Link>{' '}
                        </>
                    )}
                    <Image {...styles.copyrightImage} src={getAssetUrl('static/img/footer/ICPRecord.png')} />{' '}
                    {text2.link2 && (
                        <Link {...styles.copyrightLink} href={text2.link2.href}>
                            {text2.link2.name}
                        </Link>
                    )}
                </Text>
            )}
        </Stack>
    )
}

export default FooterCopyrightComponent
